import PropTypes from 'prop-types';
import React from 'react';

export default class TeamGroup extends React.PureComponent {
  static propTypes = {
    membersList: PropTypes.array,
  };
  render() {
    const {membersList} = this.props;
    const members = [];
    if (membersList && membersList.length > 0) {
      for (let x = 0; x < membersList.length; x++) {
        const {name, link} = membersList[x];
        if (link) {
          members.push(
            <li key={`member-${x}`} className="active">
              <a href={link} target="_blank" rel="noopener noreferrer">
                <i className="icon-tv" />
                <h3>{name}</h3>
              </a>
            </li>
          );
        } else {
          members.push(
            <li key={`member-${x}`}>
              <i className="icon-tv" />
              <h3>{name}</h3>
            </li>
          );
        }
      }
    }
    return (
      <div className="col-xs-12 col-sm-6 col-md-3">
        <ul className="team-group">{members}</ul>
      </div>
    );
  }
}
